import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 24408 24444"
    {...props}
  >
    <path
      d="M3654 3676C5841 1488 8864 135 12201 135s6359 1353 8547 3541c1996 1996 3298 4687 3509 7680l-531-201-1091-412c-325-2318-1405-4394-2983-5972-1906-1906-4541-3086-7451-3086S6657 2865 4750 4771c-1555 1555-2627 3595-2969 5873l-1629 616c233-2954 1527-5609 3502-7584zm20580 9698c-273 2878-1553 5462-3486 7395-2188 2187-5210 3540-8547 3540s-6360-1353-8547-3540c-1850-1851-3104-4298-3446-7030l1675 633c425 2048 1443 3877 2867 5301 1907 1907 4541 3086 7451 3086s5545-1179 7451-3086c1511-1510 2565-3478 2938-5678l1136-429 508-192z"
      style={{
        fill: "#2b2a29",
        stroke: "#2b2a29",
        strokeWidth: 270.887,
      }}
      className="stroke1 fill"

    />
  </svg>
)
export default SvgComponent
